import type {} from "@lit/react";
import { DashboardWidget as DashboardWidgetElement, } from "@vaadin/dashboard/vaadin-dashboard-widget.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DashboardWidgetElement, };
export type DashboardWidgetEventMap = Readonly<{}>;
const events = {} as DashboardWidgetEventMap;
export type DashboardWidgetProps = WebComponentProps<DashboardWidgetElement, DashboardWidgetEventMap>;
export const DashboardWidget = createComponent({
    elementClass: DashboardWidgetElement, events, react: React, tagName: "vaadin-dashboard-widget"
});
